import { theme } from "../../../utils/theme/godzilla_light"
import { Children } from "react"
import { Box, Typography, useMediaQuery } from "@mui/material"
import { PageSection } from "../components"
import { Trans, useTranslation } from "react-i18next"
import TransMsg from './transMessage'
import ImageListData from '../../../assets/data/educationHub/imagingData'

const styles = {
    progressionCardTitle: {
        ...theme.typography.components.sectionDescription,
        fontSize: "22.5px",
        lineHeight: "29.2px",
        color: "#fff",
        px: "27px"
    },
    progressionItemTitle: {
        ...theme.typography.components.sectionDescription,
        fontWeight: 700,
        fontSize: "14px",
        lineHeight: "18.8px",
        color: "#fff"
    },
    progressionContentLabel: {
        ...theme.typography.components.sectionDescription,
        fontSize: "11.49px",
        lineHeight: "18.8px",
        color: "#fff",
        mt: "5px"
    },
    progressionItemContainer: {
        display: "flex",
        flex: 1,
        position: "relative",
        pr: "13px",
        "&:not(:last-child)::after": {
            content: '""',
            position: "absolute",
            right: "-14px",
            top: "1%",
            bottom: "1%",
            width: "1px",
            mr: "13px",
            background: 'linear-gradient(135deg, rgba(12, 11, 13, 0.8) 0%, rgba(244, 241, 250, 0.8) 50%, rgba(12, 11, 13, 0.8) 100%)',
        }
    },
    mobileView:{
        display: "flex",
        position: "relative",
        pr: "13px"
    }
}

const ProgressionCard = (props: any) => {
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))
    const { t } = props
    const progressionData = ImageListData.progressionList
    
    return (
        <Box sx={{ backgroundColor: "#4B69F1", py: "24px",mt:"24px" }} textAlign={"left"} mx={"31px"}>
            <Typography sx={styles.progressionCardTitle}>
                {t(TransMsg.DIAGNOSTIC_HALLMARK)}
            </Typography>
            <Box sx={{ px: "27px", mt: "46px" }} display={"flex"} gap="28px" flexWrap={"wrap"}>
                {Children.toArray(progressionData.map((item: any, index: number) => {
                    return (
                        <Box sx={ isMobileX ? styles.mobileView:styles.progressionItemContainer} key={index + 1}>
                            <Box display={"flex"} flex={1}>
                                <Box>
                                    <Typography sx={styles.progressionItemTitle}>
                                        {item.title}
                                    </Typography>
                                    <Typography sx={styles.progressionContentLabel}>
                                        <Trans
                                            i18nKey={item.content}
                                            components={{ sup: <sup /> }} values={{small: "<63 µm"}} shouldUnescape={true}/>
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    )
                }))}
            </Box>
        </Box>
    )
}

const DetectionProgression = () => {
    const { t } = useTranslation()

    return (
        <PageSection
            title={t(TransMsg.DETECTION_TO_PROGRESSION)}
            description={t(TransMsg.PROGRESSION_DESCRIPTION)}
            sectionWrapperSx={{ pt:"40px" }}
            sectionCardSx={{ py: "15px", px: "23px" }}
            customElement={<ProgressionCard t={t} />}
        />
    )
}

export default DetectionProgression